import Vue from "vue";

import ProductCategoryList from "./ProductCategoryList.vue";

export function load() {
    const selector = "product-category-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(ProductCategoryList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
